module.exports = __webpack_public_path__ + "assets/img/website-9e4f64e4.png";